export function isLeadFormEmpty(props) {
    return !props.buttonText || !props.campaignId || !props.header;
}
export const prepareLeadFormLabels = (labels) => {
    return {
        firstNameLabel: labels?.leadForm_firstName_label,
        firstNamePlaceholder: labels?.leadForm_firstName_placeholder,
        lastNameLabel: labels?.leadForm_lastName_label,
        lastNamePlaceholder: labels?.leadForm_lastName_placeholder,
        emailLabel: labels?.leadForm_email_label,
        emailPlaceholder: labels?.leadForm_email_placeholder,
        phoneLabel: labels?.leadForm_phone_label,
        phonePlaceholder: labels?.leadForm_phone_placeholder,
        descriptionLabel: labels?.leadForm_description_label,
        descriptionPlaceholder: labels?.leadForm_description_placeholder,
        incorrectEmailError: labels?.checkout_incorrectEmail_error,
        requiredFieldError: labels?.checkout_personalDetailsRequiredField_error,
        phoneError: labels?.checkout_personalDetailsPhone_error,
        somethingWentWrongMessage: labels?.common_somethingWentWrong_message,
        successLabel: labels?.common_success_label,
        successPopUpMessage: labels?.common_formSuccessPopUp_message,
        postalCodePlaceholder: labels?.leadForm_postalCode_placeholder,
        postalCodeLabel: labels?.leadForm_postalCode_label,
        cityPlaceholder: labels?.leadForm_city_placeholder,
        cityLabel: labels?.leadForm_city_label,
        searchInputPlaceholder: labels?.leadForm_address_placeholder,
        searchInputLabel: labels?.leadForm_address_label,
        addressPlaceholder: labels?.leadForm_street_placeholder,
        addressLabel: labels?.leadForm_street_label,
        configurationButton: labels?.leadForm_configuration_button,
        configurationTitle: labels?.leadForm_configuration_header,
        filters_selectAll_label: labels?.filters_selectAll_label,
        filters_clearAll_label: labels?.filters_clearAll_label,
        common_confirm_button: labels?.common_confirm_button,
    };
};
